import RcSlider from 'rc-slider'
import 'rc-slider/assets/index.css'
import React from 'react'
import { withFormikSupport } from '../../hocs/withFormikSupport'
import * as S from './Slider.styled'
import type { Props } from './types'

const SliderComponent = ({
  min = 1,
  max = 100,
  step = 1,
  value,
  label,
  disabled = false,
  onChange,
  onChangeComplete,
  onBlur,
}: Props) => {
  const handleChange = (value: number | number[]) => {
    if (Array.isArray(value)) {
      throw new Error('RangeSlider: value should be an array')
    }

    onChange?.(value)
  }

  const handleChangeComplete = (value: number | number[]) => {
    if (Array.isArray(value)) {
      throw new Error('RangeSlider: value should be an array')
    }

    onChangeComplete?.(value)
  }

  return (
    <S.Container>
      <RcSlider
        min={min}
        max={max}
        step={step}
        value={value}
        ariaLabelForHandle={label}
        styles={{
          rail: {
            background: 'var(--border-secondary)',
            height: 2,
            borderRadius: 0,
          },
          track: {
            background: 'var(--text-primary)',
            height: 2,
            borderRadius: 0,
          },
        }}
        disabled={disabled}
        onChange={handleChange}
        onBlur={onBlur}
        onChangeComplete={handleChangeComplete}
      />
    </S.Container>
  )
}

export const Slider = withFormikSupport(SliderComponent)
